import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'pakistan_does_facility_pay_workers_legally_required_yearly'

export const dataPointDefinition = {
  retracedId: 'pakistan_does_facility_pay_workers_legally_required_yearly',
  name: 'Pakistan: Does the facility pay workers the legally required yearly profit-based bonus?',
  description:
    'This question is specific to Pakistan only. Please consult the Law Overlay for more information on applicable legal requirements.',
  meta: {
    slcpMeta: {
      key: 'wb-wag-104',
      number: 'WB-WAGE-93',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wb-wag-104', version: '1.7.0', provider: 'slcp'}],
  sortingId: 35490,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
